'use client';

export default function PromotionBottomAd() {
  return (
    <div className="w-full bg-slate-100 border border-dashed border-slate-300 rounded-lg p-8 text-center">
      <p className="text-slate-400 text-sm">Promotion Bottom Ad Placeholder</p>
      <p className="text-slate-300 text-xs mt-1">728x90 (Desktop) / 320x50 (Mobile)</p>
    </div>
  );
}
